var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "signs__description" },
              _vm._l(Object.entries(_vm.icons), function(ref) {
                var text = ref[0]
                var icon = ref[1]
                return _c(
                  "span",
                  { key: text },
                  [
                    _c("v-icon", { class: "multiple-signal--" + icon.color }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(icon.name) +
                          "\n                "
                      )
                    ]),
                    _vm._v(
                      "\n                " + _vm._s(text) + "\n            "
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]
        },
        proxy: true
      },
      {
        key: "signs",
        fn: function() {
          return [
            _vm.sign_data
              ? _c("MonitorMultipleSigns", { attrs: { data: _vm.sign_data } })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function() {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                show_download_pdf_btn: _vm.show_download_pdf_btn
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              },
              scopedSlots: _vm._u([
                {
                  key: "table_description",
                  fn: function() {
                    return [
                      _vm._l(_vm.icons_table_description, function(ref) {
                        var text = ref.text
                        var name = ref.name
                        var display_info = ref.display_info
                        return _c(
                          "div",
                          { key: text },
                          [
                            _vm._v("\n                    " + _vm._s(text)),
                            _c("br"),
                            _vm._v(" "),
                            _vm._l(Object.entries(display_info), function(ref) {
                              var alert_text = ref[0]
                              var value = ref[1]
                              return _c(
                                "span",
                                { key: text + "_" + alert_text },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(alert_text) +
                                      "：\n                        "
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      class: "multiple-signal--" + value.color
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(name) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("\n                    說明:"),
                        _c("br"),
                        _vm._v(
                          "\n                    1. 「--」 表示該欄位無資料。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                    2.雨量資料問題請撥打(02)2349-7972。"
                        ),
                        _c("br")
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }